module.exports = __webpack_public_path__ + "static/media/illuminance.36af5531.svg";